import React from 'react';

const Contact = () => {
  return (
    <div>
      <h2>This is contact page</h2>
    </div>
  );
};

export default Contact;